<template>
  <div>
    <list
      row-key="UserId"
      ref="list"
      :expand-all-row="true"
      :page="page"
      :query-params="params"
      :show-checkbox="$permission.canWrite()&&showCheckbox"
      :show-query="showQuery"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="宿舍地址">
          <el-input size="mini" v-model="params.DormitoryAddr" placeholder="请填宿舍地址" />
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="DormitoryAddr" label="宿舍地址" />
        <el-table-column prop="DormitoryNumber" label="房号" />
        <el-table-column prop="Capacity" label="容纳人数" />
        <el-table-column prop="CreateTime" label="创建时间" :min-width="isMB?100:''">
          <template slot-scope="{row}">
            <span>{{$commonJs.toDateString(row.CreateTime)}}</span>
          </template>
        </el-table-column>
        <slot name="column"></slot>
      </template>
    </list>
    <export-dialog ref="exportDialog" />
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import exportDialog from "./exportDialog";

export default {
  mixins: [listMixin],
  components: { list, exportDialog },
  props: {
    showCheckbox: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      api: require("@/api/lo/dorm").default,
      params: {
        DormitoryAddr: "",
      },
      isMB: this.$store.state.isMB,
    };
  },
  methods: {
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error("删除失败，" + res.Msg);
        }
      });
    },
    export() {
      this.$refs.exportDialog.open().then((that) => {
        that.getData(this.params);
      });
    },
  },
};
</script>